import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getNextBestActionsPublic, putNextBestActionFeedbackPublic } from '../services/NextBestActionPublicService';

export const useNextBestActionPublicGetNextBestActionsPublic = createDCHook(
  'getNextBestActionsPublic',
  collapseDataFromCall(getNextBestActionsPublic),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useNextBestActionPublicPutNextBestActionFeedbackPublic = createMutationHook(
  collapseParams(
    collapseParams(putNextBestActionFeedbackPublic, 'requestBody', 'data'),
    'data',
    'actionId',
    'contextId',
    'servingPointId',
    'treatmentVariationId',
    'status',
    'channel',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: ['actionId', 'contextId', 'servingPointId', 'treatmentVariationId', 'status', 'channel'],
      },
    ],
  },
);
